// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"cdbc6fbe","453":"1e66e29c","455":"8862cf0a","977":"293ae358"}[chunkId] + ".chunk.js";
};